<!-- Modal: All packages by Account -->
<div class="modal fade" bsModal #accountDetails="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-events-name" class="modal-title pull-left" style="max-width: 70%; word-break: break-all;">Account: <b>{{selectedAccountName}}</b></h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="closeAccountModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="padding-top: 30px;max-height: 350px; overflow: auto;">
                <div class="row">
                    <div class="col-xs-12">
                        <p-table
                            *ngIf="isAccountModalOpen"
                            #table2
                            [rows]="10" 
                            [value]="accountPackageList" 
                            [totalRecords]="totalAccountPackageCount"
                            [paginator]="totalAccountPackageCount > 10"
                            [lazy]="true"
                            (onLazyLoad)="loadNextAccountPagination($event)"
                        >
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width:50px;text-align: center;">#</th>
                                    <th>Package Name</th>
                                    <th style="text-align: center;">Package Type</th>
                                    <th style="text-align: center;">Active Status</th>
                                    <th style="text-align: center;">Purchase Date</th>
                                    <th style="text-align: center;">Date Till Valid</th>
                                    <th style="text-align: center; width: 130px;">Package Status</th>
                                </tr>
                                <tr 
                                    *ngIf="accountPackageList && accountPackageList.length === 0"
                                    style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;"
                                >
                                    <td colspan="7">
                                        <div style="padding: 5px;text-align: center;">
                                            No record(s) found
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-package let-i="rowIndex">
                                <tr class="table-striped">
                                    <td style="text-align: center;">{{i+1}}</td>
                                    <td style="word-break: break-all;">{{package.packageName}}</td>
                                    <td style="word-break: break-all; text-align: center;">{{package.packageType}}</td>
                                    <td 
                                        *ngIf="payload.subscriptionType==='PREPAID'"
                                        style="word-break: break-all; text-align: center;"
                                        [ngClass]="{'package-valid': package.status === 'Active', 'package-invalid': package.status === 'Inactive'}"
                                    >
                                        {{package.status}}
                                    </td>
                                    <td style="text-align: center;">{{package.purchaseDate | date: dateFormat}}</td>
                                    <td style="text-align: center;">{{package.expiryDate | date: dateFormat}}</td>
                                    <td 
                                        style="text-align: center;" 
                                        [ngClass]="{'package-valid': package.isValid, 'package-invalid': !package.isValid}"
                                    >
                                        {{package.currentStatus}}
                                        <br />
                                        <button
                                            class="btn btn-xs btn-primary"
                                            (click)="showPackageDetails(package)"
                                            tooltip="Package details" 
                                        >
                                            View details <i class="fa fa-external-link"></i>
                                        </button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
            <div class="modal-footer" style="text-align: center;">
                <button class="btn btn-sm btn-danger" (click)="closeAccountModal()">Close</button>
            </div>
        </div>
    </div>
</div>
<!-- Modal: All packages by Account ENDS-->

<!-- Modal: Package Details -->
<div class="modal fade" bsModal #packageDetails="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-events-name" class="modal-title pull-left" style="max-width: 70%; word-break: break-all;">Package: <b>{{selectedPackageName}}</b></h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="closePackageModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="padding-top: 30px;">
                <div class="row">
                    <div class="col-xs-12">
                        <div *ngIf="selectedPackage">
                            <p><b>Unit Price:</b> &nbsp;{{selectedPackage.currency === 'INR' ? '₹' : (selectedPackage.currency === 'USD' ? '$' : null)}} {{selectedPackage.amount | number:'.2'}}</p>
                            <p><b>Expiry Date:</b> {{selectedPackage.expiryDate | date: dateFormat}}</p>
                            <br/>
                            <table id="packageDetailsTable" class="table table-bordered" style="margin-bottom: 0px;">
                                <thead  >
                                    <tr>
                                        <th>Service Name</th>
                                        <th>Units</th>
                                        <th>Units Used</th>
                                        <th>Units Remaining</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    <tr class="table-striped" >
                                        <td>Fundus</td>
                                        <td>{{selectedPackage.fundusUnitAvailed}} unit(s)</td>
                                        <td>{{selectedPackage.fundusUnitAvailed - selectedPackage.fundusUnit}} unit(s)</td>
                                        <td>{{selectedPackage.fundusUnit}} unit(s)</td>
                                    </tr>
                                    <tr class="table-striped" >
                                        <td>Refraction</td>
                                        <td>{{selectedPackage.refractionUnitAvailed}} unit(s)</td>
                                        <td>{{selectedPackage.refractionUnitAvailed - selectedPackage.refractionUnit}} unit(s) </td>
                                        <td>{{selectedPackage.refractionUnit}} unit(s)</td>
                                    </tr>
                                    <tr class="table-striped">
                                        <td>Telerefraction</td>
                                        <td>{{selectedPackage.teleRefractionUnitAvailed}} unit(s)</td>
                                        <td>{{selectedPackage.teleRefractionUnitAvailed - selectedPackage.teleRefractionUnit}} unit(s) </td>
                                        <td>{{selectedPackage.teleRefractionUnit}} unit(s)</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>                        
                    </div>
                </div>
            </div>
            <div class="modal-footer" style="text-align: center;">
                <button class="btn btn-sm btn-danger" (click)="closePackageModal()">Close</button>
            </div>
        </div>
    </div>
</div>
<!-- Modal: Package Details ENDS -->

<!-- Main Content -->
<section class="box">
    <div class="tile-progress bg-white text-left">
        <div class="row">
            <div class="col-xs-12 col-sm-4">
                <label>Select Account Type</label>
                <ng-select [items]="accounts" [(ngModel)]="accountType" name="accounts"
                    placeholder="Select account type" [clearable]="false" [searchable]="false">
                </ng-select>
            </div>
            <div class="col-xs-12 col-sm-4" style="width:20%">
                <label>Select Date Range</label>
                <ngx-mat-drp 
                    #dateRangePicker
                    name="dateSelect"
                    [options]="calendarOptions"
                    (selectedDateRangeChanged)="updateDateRange($event)" 
                >
                </ngx-mat-drp>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <button
                    class="btn btn-sm searchButton"
                    style="height:38px;background-color: rgb(87,200,231);color:white;font-size: 14px;"
                    (click)="searchPackagesByFilter()"
                    tooltip="Search Packages" 
                >
                    Get Details
                </button>
            </div>
        </div>
    </div>

    <div class="content-body padding-top-20 padding-bottom-20">
        <div class="row">
            <div class="col-xs-12">
                <p-table 
                    #table1
                    [rows]="10" 
                    [value]="packageList" 
                    [totalRecords]="totalPackageCount"
                    [paginator]="totalPackageCount>10"
                    [lazy]="true"
                    (onLazyLoad)="loadNextPagination($event)"
                >
                    <ng-template pTemplate="header">
                        <tr >
                            <th style="width:100px;text-align: center;">#</th>
                            <th>Account Name</th>
                            <th *ngIf="payload.subscriptionType==='PREPAID'">Package Name</th>
                            <th *ngIf="payload.subscriptionType==='PREPAID'" style="text-align: center;">Package Type</th>
                            <th *ngIf="payload.subscriptionType==='PREPAID'" style="text-align: center;">Active Status</th>
                            <th *ngIf="payload.subscriptionType==='PREPAID'" style="text-align: center;">Purchase Date</th>
                            <th style="text-align: center;">Date Till Valid</th>
                            <th *ngIf="payload.subscriptionType==='PREPAID'" style="text-align: center;">Package Status</th>
                        </tr>
                        <tr 
                            *ngIf="packageList && packageList.length === 0"
                            style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;"
                        >
                            <td *ngIf="payload.subscriptionType==='PREPAID'" colspan="8">
                                <div style="padding: 5px;text-align: center;">
                                    No record(s) found
                                </div>
                            </td>
                            <td *ngIf="payload.subscriptionType==='POSTPAID'" colspan="3">
                                <div style="padding: 5px;text-align: center;">
                                    No record(s) found
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-package let-i="rowIndex">
                        <tr class="table-striped">
                            <td style="text-align: center;">{{i+1}}</td>
                            <td>
                                {{package.accountName}}
                                <br />
                                <button 
                                    *ngIf="payload.subscriptionType==='PREPAID'"
                                    class="btn btn-xs"
                                    (click)="getPackagesByAccount(package.accountId, package.accountName)"
                                    tooltip="View all packages" 
                                >
                                    View All <i class="fa fa-external-link"></i>
                                </button>
                            </td>
                            <td *ngIf="payload.subscriptionType==='PREPAID'" style="word-break: break-all;">
                                {{package.packageName}}
                            </td>
                            <td *ngIf="payload.subscriptionType==='PREPAID'" style="word-break: break-all; text-align: center;">
                                {{package.packageType}}
                            </td>
                            <td 
                                *ngIf="payload.subscriptionType==='PREPAID'"
                                style="word-break: break-all; text-align: center;"
                                [ngClass]="{'package-valid': package.status === 'Active', 'package-invalid': package.status === 'Inactive'}"
                            >
                                {{package.status}}
                            </td>
                            <td *ngIf="payload.subscriptionType==='PREPAID'" style="text-align: center;">{{package.purchaseDate | date: dateFormat}}</td>
                            <td style="text-align: center;">{{package.expiryDate | date: dateFormat}}</td>
                            <td 
                                *ngIf="payload.subscriptionType==='PREPAID'" 
                                style="text-align: center;" 
                                [ngClass]="{'package-valid': package.isValid, 'package-invalid': !package.isValid}"
                            >
                                {{package.currentStatus}}
                                <br />
                                <button
                                    class="btn btn-xs"
                                    (click)="showPackageDetails(package)"
                                    tooltip="Package details" 
                                >
                                    View details <i class="fa fa-external-link"></i>
                                </button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</section>
<!-- Main Content ENDS -->